/*
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 15:39:12
 * @Descripttion:
 */
import { POST } from '../assets/js/utils'
import qs from "qs"

const URL = {
    CheckCode:'/sdcar/getCheckCode',    // 获取验证码
    login:'/sdcar/login',   // 登录
    userInfo:'/sdcar/user-personal',    // 获取用户信息

    RemanentNum: '/sdcar/query-num',   // 获取剩余名额
    UserEquityCount: '/sdcar/userEquityCount',   // 获取剩余名额
}

function GetCheckCode(pars = {}){
    return POST(URL.CheckCode,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}
function GetLogin(pars = {}){
    return POST(URL.login,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}
function GetUserInfo(pars = {}){
    return POST(URL.userInfo,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}
function GetRemanentNum(pars = {}){
    return POST(URL.RemanentNum,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}
function UserEquityCount(pars = {}) {
    return POST(URL.UserEquityCount, qs.stringify(pars), 1, "application/x-www-form-urlencoded")
}




export {
    GetCheckCode, GetLogin, GetUserInfo, GetRemanentNum, UserEquityCount
}